import React from 'react';
import {connect, DispatchProp, useSelector} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as BogoIco} from "../../../../../images/icons/bogo.svg";
import {RootState} from "../../../../../reducers";
import PromotionHelper from "../../../../services/Menu/services/Promotion/PromotionHelper";
import ItemViewHelper from "../../../../services/Menu/services/Item/ItemViewHelper";
import ItemHelper from "../../../../services/Menu/services/Item/ItemHelper";
import Utils from "../../../../utils/Utils";
import MenuProductListItemComponent from "../List/MenuProductListItemComponent";
import {getAvailabilities, getItems} from "../../../../services/Menu/reducer";
import {getCartTotal} from "../../../../services/Cart/reducer";
import {getSession} from "../../../../services/Location/reducer";


interface OwnProps {
    menu: any,
    promotions: any,
    addItem: (id: any, categoryId: any, menuId: any) => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuPromotionsCategoryComponent = (props: Props) => {
    const {t} = useTranslation();
    const cartTotal = props.cartTotal;
    let promotions = props.promotions;
    if (promotions === undefined || !promotions || promotions.length === 0) {
        return null;
    }
    let activePromotions = PromotionHelper.getActivePromotionsForCategory(promotions, cartTotal);
    const getItemPromotions = (promotion: any) => {
        return promotion.entities.map((x: any) => {
            return ItemViewHelper.parseItem(ItemHelper.getItem(props.items, x.entity_id), props.availabilities, activePromotions, props.session.pickup_at, undefined);
        }).filter((x: any) => x !== undefined);
    }
    const renderIcon = (promotion: any) => {
        switch (promotion.type) {
            case "BOGO":
                return (
                    <BogoIco/>
                )
            case "vouchers":
                return (
                    <BogoIco/>
                )
        }
        return (
            <BogoIco/>
        )
        // return null;
    }
    return (
        <div className="menu-promotions-category-container">
            {activePromotions.map((promotion: any) => {
                return (
                    <section className="menu-category container scrollspy-section"
                             id={'category-promotion-' + promotion.id} key={promotion.id}>
                        <h4>
                            {renderIcon(promotion)}
                            {promotion.name}
                        </h4>
                        <p dangerouslySetInnerHTML={{__html: Utils.nl2brString(promotion.description)}}></p>
                        <div className="menu-items menu-items-grid">
                            {
                                getItemPromotions(promotion).sort((a: any, b: any) => a.name.localeCompare(b.name)).map((item: any) => {
                                        return (
                                            <MenuProductListItemComponent promotions={promotions}
                                                                          menuId={props.menu.id} addItem={props.addItem}
                                                                          categoryId={item.id} product={item}
                                                                          key={'item-' + item.id + '-' + promotion.id}/>
                                        )
                                    }
                                )
                            }
                        </div>
                    </section>
                )
            })}
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    session: getSession(state.session),
    availabilities: getAvailabilities(state.menu),
    cartTotal: getCartTotal(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuPromotionsCategoryComponent));